import { useNavigate } from 'react-router-dom';
import { LocationProjectRecord, LocationRecordSection } from '../../../Api/Locations/locationsApi';
import { formatDate } from '../../../utils/helpers';
import { RelatedRecordsCard } from '../../Compounds/RelatedRecordsTable/RelatedRecordsCard';
import { RelatedRecordsColumn } from '../../Compounds/RelatedRecordsTable/RelatedRecordsTable';

const columns: RelatedRecordsColumn<LocationProjectRecord>[] = [
  { header: 'Project Name', cellClass: 'break-words', text: (project) => project.name || '' },
  { header: 'Status', headerClass: 'w-32', cellClass: 'truncate', text: (project) => project.status || '' },
  { header: 'Expected Completion', headerClass: 'w-36', text: (project) => formatDate(project.expected_completion) }
];

export interface LocationProjectsTableProps {
  projects: LocationRecordSection<LocationProjectRecord>;
  count: number | null | undefined;
}

export function LocationProjectsTable({ projects, count }: LocationProjectsTableProps) {
  const navigate = useNavigate();

  return (
    <RelatedRecordsCard
      title="Projects"
      count={count}
      section={projects}
      emptyText="No projects at this location"
      testId="location-projects"
      recordKey={(project) => project.id}
      columns={columns}
      openTitle="Open Project"
      onOpen={(project) => navigate(`/projects/${encodeURIComponent(project.id)}`)}
    />
  );
}
